export enum AVATAR_SCREENS {
  BEGIN = 0,
  CUSTOMISE = 1,
  FINAL = 2,
  CUSTOM_UI = 3,
}
